module.exports = __webpack_public_path__ + "static/media/phoneBlob.958e8b49.png";